import React, { useState, useEffect } from 'react';
import { animate, motion } from "framer-motion"

import logo from "../asstes/logo.png"
import logout from "../asstes/dashboard/logout.png"
import order from "../asstes/dashboard/new.png"

import OrderDetails from "../Components/orderDetails"

import CancelDetailOverlay from "../Components/CancelDetailOverlay"

import loadingIcon from "../asstes/loadingIconBlue.gif"

import home from "../asstes/dashboard/home.png"

import actions from "../asstes/dashboard/actions.png"





import OrdersForm from "../Components/ordersForm"




import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";


import '../styles/client.css';

import { getDatabase, ref, update, push, get } from "firebase/database";

function writeUserData(userId, name, email, imageUrl) {

    const db = getDatabase();
    push(ref(db, 'users'), {
        username: name,
        email: email,
        profile_picture: imageUrl
    });
}




const ClientSpace = (params) => {


    const navigate = useNavigate();
    const location = useLocation();

    

    const [showCancelDetailOverlay, setShowCancelDetailOverlay] = useState(false);

    const [charging_location , setCharging] = useState("");
    const [discharging_location, setDischarging_location] = useState("");
    const [size, setSize] = useState("");
    const [vehicle_type, setVehicle_type] = useState("");
    const [weight, setWeight] = useState("");

    const [payment_method, setPayment_method] = useState("");

    const [phone, setPhone] = useState("");
    const [clientName, setClientName] = useState("");
    

   
    const [showSignUp, setShowSignUp] = useState(false);
    const [showLogOutOverlay, setShowLogOutOverlay] = useState(false);

    
    const [page1, setPage1] = useState(false);
    const [page2, setPage2] = useState(false);
    const [loading, setLoading] = useState(true);

    const [pageLoaded, setPageLoaded] = useState(false);

    const [page6, setPage6] = useState(false);

    const [allOrders, setAllOrders] = useState([]);

    const [selectedStateFilter, setSelectedStateFilter] = useState(0);
    const [filterOrders, setFilterOrders] = useState([]);

    const [showOrderAction, setShowOrderAction] = useState(false);

    const [showOrdersOverlay, setShowOrdersOverlay] = useState(false);
    
    const [selectedOrder, setSelectedOrder] = useState(null);


    const [showSelectOption2, setShowSelect2] = useState(false);

    
    const [waitingCount, setWaitingCount] = useState(0);
    
    const [CanceledCount, setCanceledCount] = useState(0);
    
    const [delivredCount, setDelivredCount] = useState(0);



    async function cancelOrder(shipmentID) {

        const db = getDatabase();

        const data = {
            time_canceled: formatDate(new Date()),
            state : "cn"
        };

        const id = ref(db, 'Shipment/' + shipmentID);


        update(id, data).then(()=>{
            getordersByUser(location.state.userId);
        });

        

    }

    const formatDate = (date)=> {

        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = date.getFullYear();

        var res = dd + '/' + mm + '/' + yyyy;
        return res;
    } 

    

    const filterByState = (filter) => {

        var filterRes = [];
        if (filter == "a") {
            setFilterOrders(allOrders);
        } else {

            allOrders.map((item) => {
                console.log(item)
                if (item.state === filter) {
                    filterRes.push(item);
                }
            })

            console.log(filterRes)
            setFilterOrders(filterRes);
        }
    }

    

    const getordersByUser = (clientID)=> {

            const db = getDatabase();
            const shipments = ref(db, 'Shipment');
            
        get(shipments)
            .then((snapshot) => {
                const data = snapshot.val();
                const list = Object.entries(data)
                console.log(list)
                var clientorders = [];
                list.forEach(element => {
                    console.log(clientID)
                    console.log(element[1].client_id)
                    if (element[1].client_id === clientID) {
                        console.log("orders exsist")
                        clientorders.push({ id: element[0], units_description : element[1].units_description ,client: element[1].name, client_id: element[1].client_id, date: element[1].time_requested, from: element[1].charging_location, to: element[1].discharging_location, paiment: element[1].payment_method, price: element[1].price, state: element[1].state, weight: element[1].weight, vehicle_type: element[1].vehicle_type, description: element[1].description, size: element[1].size , transporter_id:element[1].transporter_id , palette_number : element[1].palette_number })
                        setFilterOrders(clientorders)
                        setAllOrders(clientorders)

                    }
                });

                getStat();
            })
    }



    const getStat = ()=> {
        var w = 0;
            var cn = 0;
            var d = 0;

        allOrders.map((item)=> {
            
            if(item.state === "w"){
                w++;
            }
            if(item.state === "cn"){
                cn++;
            }

            if(item.state === "d"){
                d++;
            }

        })

        
        setWaitingCount(w);
        setDelivredCount(d);
        setCanceledCount(cn)
    }
    const logoutHandler = ()=> {
        navigate('/');
    }
    const SaveShipment = () => {



        //const userId = props.route.params.userId
        
        console.log(location.state.userId)
        
        if(charging_location == "" || discharging_location == "" || size =="" || weight == "" || vehicle_type == "" || payment_method ==""){
            console.log("empty")
        }else {
            console.log("saving")
            const db = getDatabase();

            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = dd + '/' + mm + '/' + yyyy;


            push(ref(db, 'Shipment'), {
                client_id: location.state.userId,
                charging_location: charging_location,
                discharging_location: discharging_location,
                description: "",
                size: size,
                price : 1500,
                time_requested: today,
                vehicle_type: vehicle_type,
                weight : weight,
                state:"w",
                phone:phone,
                name:clientName,
                payment_method:payment_method,
                
            });

            getordersByUser(location.state.userId);
            setShowSignUp(false)

        }
    }
    

    useEffect(() => {

        window.addEventListener('click', function (e) {
            if (document.getElementById('select-option2') != null){
                if (!document.getElementById('select-option2').contains(e.target)) {
                    setShowSelect2(false)

                }

                
            }

            if (document.getElementById('signIn-overlay') != null && document.getElementById('show-overlay-btn2') != null && this.document.getElementById("show-order-btn3") != null) {
                if (!document.getElementById('signIn-overlay').contains(e.target) && !document.getElementById('show-overlay-btn2').contains(e.target) && !this.document.getElementById("show-order-btn3").contains(e.target)) {
                    setShowSignUp(false);

                }
            }


            if (document.getElementById('signIn-overlay') != null && document.getElementById('show-overlay-btn2') != null && this.document.getElementById("show-order-btn3") != null && this.document.getElementById("logout-conf") != null) {
                if (!document.getElementById('signIn-overlay').contains(e.target) && !document.getElementById('show-overlay-btn2').contains(e.target) && !this.document.getElementById("show-order-btn3").contains(e.target)) {
                    setShowSignUp(false);

                }
            }
            
            

        });


        getordersByUser(location.state.userId)
        setTimeout(() => {
            setPageLoaded(true);
            setLoading(false);
            setPage2(true);
        }, 3000)

    }, []);

    useEffect(()=> {
        
        getordersByUser(location.state.userId)
    },[page1])




    

    return (

        <div>
        <motion.div className="dashboard-home" id="page1"
            initial={{ opacity: 0 }}
            animate={pageLoaded ? { opacity: 1 , transition:{delay : 2}} : { opacity: 0 }}
        >

                <div className="side-nav">
                    <div className="nav-item"
                        onClick={() => {
                            setPage6(true)
                        }}
                    >

                        <motion.div
                            className="notification-overlay"
                            initial={{ scale: 0 }}
                            animate={page6 ? { scale: 1, origin: "left", transition: { ease: "easeInOut" } } : { scale: 0 }}
                        >

                        </motion.div>
                        <img src={logo} alt="" />
                        <motion.div
                            className="selected-background"
                            initial={{ scale: 0 }}
                            animate={page6 ? { scale: 1, transition: { ease: "easeInOut" } } : { scale: 0 }}
                        >

                        </motion.div>
                    </div>
                    <div className="hr"></div>
                    <motion.div
                        className="nav-item selected"
                        onClick={() => {
                            setPage1(true)
                            
                            setPage2(false)
                        }}
                    >
                        <motion.div
                            className="selected-background"
                            initial={{ scale: 0 }}
                            animate={page1 ? { scale: 1, transition: { ease: "easeInOut" } } : { scale: 0 }}
                        >

                        </motion.div>

                        <img src={home} alt="" />
                    </motion.div>

                    <motion.div
                        className="nav-item selected"
                        id="show-order-btn3"
                        onClick={() => {
                            setPage1(false)
                            setPage2(true)
                            console.log("jsjsj")
                        }}
                    >
                        <motion.div
                            className="selected-background"
                            initial={{ scale: 0 }}
                            animate={page2 ? { scale: 1, transition: { ease: "easeInOut" } } : { scale: 0 }}
                        >

                        </motion.div>

                        <img src={order} alt="" />
                    </motion.div>
                    
                    <div id="showLogOut" className="nav-item last-nav-item"  onClick={()=> {
                        
                        console.log("cc")
                        setShowLogOutOverlay(true);
                        
                    }}>
                        <img src={logout} alt="" />
                        <motion.div
                            className="selected-background"
                            initial={{ scale: 0 }}
                        >

                        </motion.div>
                    </div>
                </div>

                <div className="pages-container">
                    {
                        page1 ?
                    <motion.div className="dashboard-orders orders-page" id="page2"
                        initial={{zIndex:2 , opacity: 0 , zIndex : 1}}
                        animate={page1 ? { opacity: 1 , zIndex:2} : { opacity: 0 ,zIndex:1 }}

                    >

                        <div className="left-orders">
                            <div className="dash-page-title">
                                <p>Korsaa</p>
                                <p>Mes ordres</p>
                            </div>

                            <div className="orders-filters">
                                
                                <div onClick={()=> {
                                    setSelectedStateFilter(0);
                                    setShowOrderAction(-1);
                                    filterByState("a");
                                }}>
                                    <p>tout</p>
                                    <motion.div 
                                    className="selected-order-filter"
                                    initial={{width:"100%" }}
                                    animate={selectedStateFilter == 0 ? {width:"100%"} : {width:0}}
                                    >

                                    </motion.div>
                                </div>

                                <div onClick={() => {
                                    setSelectedStateFilter(1);
                                    setShowOrderAction(-1);
                                    filterByState("w");
                                }}>
                                    <p>En Attente</p>
                                    <motion.div
                                        className="selected-order-filter"
                                        initial={{ width: "100%" }}
                                        animate={selectedStateFilter == 1 ? { width: "100%" } : { width: 0 }}
                                    >

                                    </motion.div>
                                </div>

                                <div onClick={() => {
                                    setSelectedStateFilter(2);
                                    setShowOrderAction(-1);
                                    filterByState("c");
                                }}>
                                    <p>Confirmé</p>
                                    <motion.div
                                        className="selected-order-filter"
                                        initial={{ width: "100%" }}
                                        animate={selectedStateFilter == 2 ? { width: "100%" } : { width: 0 }}
                                    >

                                    </motion.div>
                                </div>

                                

                                <div onClick={() => {
                                    setSelectedStateFilter(4);
                                    setShowOrderAction(-1);
                                    filterByState("d");
                                }}>
                                    <motion.div
                                        className="selected-order-filter"
                                        initial={{ width: "100%" }}
                                        animate={selectedStateFilter == 4? { width: "100%" } : { width: 0 }}
                                    >

                                    </motion.div>
                                    <p>Livré</p>
                                </div>

                                <div onClick={() => {
                                    setSelectedStateFilter(5);
                                    setShowOrderAction(-1);
                                    filterByState("cn");
                                }}>
                                     <motion.div
                                        className="selected-order-filter"
                                        initial={{ width: "100%" }}
                                        animate={selectedStateFilter == 5 ? { width: "100%" } : { width: 0 }}
                                    >

                                    </motion.div>
                                    <p>Annulé</p>
                                </div>

                                <div onClick={() => {
                                    setSelectedStateFilter(6);
                                    setShowOrderAction(-1);
                                    filterByState("oos");
                                }}>
                                     <motion.div
                                        className="selected-order-filter"
                                        initial={{ width: "100%" }}
                                        animate={selectedStateFilter == 6 ? { width: "100%" } : { width: 0 }}
                                    >

                                    </motion.div>
                                    <p>Hors Service</p>
                                </div>
                            </div>
                            

                           
                                

                            <div className="orders-list">
                                <motion.div className="order-list-item">
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                        >Id</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                        >Client</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                         >Date</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                        >From</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                         >To</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                        >Payment</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                         >Price</motion.p>
                                    <motion.p
                                        initial={{ opacity: 1 }}
                                        >State</motion.p>
                                </motion.div>
                                {
                                    filterOrders.length == 0 ? 
                                    filterOrders.map((item , index)=> {
                                        return(
                                            <div>
                                                <div className="order-list-item">
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        >{index + 1}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.client}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                       
                                                    >{item.date}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.from}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                     
                                                    >{item.to}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.paiment}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                       
                                                    >{item.price} DA</motion.p>
                                                    <motion.p className="state-container"
                                                        initial={{ opacity: 1 }}
                                                        >
                                                        <div className={item.state === "w" ? "stat-circle bkYellow" :item.state === "c" ? "stat-circle bkBlue" :item.state === "d"? "stat-circle bkgreen" : "stat-circle bkred"} >
                                                            {item.state === "w" ? <p>W</p> : <p>{item.state.replace("cn", "-")}</p>}
                                                        </div>
                                                    </motion.p>
                                                    <div className="action"
                                                        onClick={() => {
                                                            setShowOrderAction(showOrderAction == index ? -1 : index)
                                                        }}
                                                    >
                                                        <img src={actions} alt="" />
                                                    </div>
                                                </div>

                                                <motion.div className="order-list-item order-actions-container"
                                                   initial={{ height: "0", opacity: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}
                                                   animate={showOrderAction == index ? { height: "60px", opacity: 1, marginTop: "10px", marginBottom: "10px", paddingTop: "15px", paddingBottom: "15px", transition: { delay: 0 } } : { height: "0", opacity: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, transition: { delay: 0 } }}
                                                >

                                                    
                                                    <motion.div className="order-action bkRed"
                                                        initial={{ opacity: 0 }}
                                                        animate={showOrderAction == index? { opacity: 1 } : { opacity: 0 }}
                                                        onClick={() => {
                                                            
                                                            setSelectedOrder(item);
                                                            setShowOrdersOverlay(true);
                                                        }}

                                                    >
                                                        <p>Details</p>
                                                    </motion.div>
                                                    <motion.div className="order-action bkYellow"
                                                        initial={{ opacity: 0 }}
                                                        animate={showOrderAction == index? { opacity: 1 } : { opacity: 0 }}
                                                        onClick={()=> {
                                                            setSelectedOrder(item)
                                                            setShowCancelDetailOverlay(true);
                                                        }}
                                                    >
                                                        <p>Cancel</p>
                                                    </motion.div>
                                                </motion.div>
                                            </div>
                                        )
                                    }
                                    )
                                
                                    :
                                    
                                    filterOrders.map((item , index)=> {
                                        return(
                                            <div>
                                                <div className="order-list-item">
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        >{index + 1}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                       
                                                    >{item.client}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.date}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.from}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.to}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.paiment}</motion.p>
                                                    <motion.p
                                                        initial={{ opacity: 1 }}
                                                        
                                                    >{item.price} DA</motion.p>
                                                    <motion.p className="state-container"
                                                        initial={{ opacity: 1 }}
                                                        >
                                                       <div className={item.state === "w" ? "stat-circle bkYellow" :item.state === "c" ? "stat-circle bkBlue" :item.state === "d"? "stat-circle bkgreen" : "stat-circle bkred"} >
                                                            {item.state === "w" ? <p>W</p> : <p>{item.state.replace("cn", "-")}</p>}
                                                        </div>
                                                    </motion.p>
                                                    <div className="action"
                                                        onClick={() => {
                                                            setShowOrderAction(showOrderAction == index ? -1 : index)
                                                        }}
                                                    >
                                                        <img src={actions} alt="" />
                                                    </div>
                                                </div>

                                                <motion.div className="order-list-item order-actions-container"
                                                    initial={{ height: "0", opacity: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}
                                                    animate={showOrderAction == index ? { height: "60px", opacity: 1, marginTop: "10px", marginBottom: "10px", paddingTop: "15px", paddingBottom: "15px", transition: { delay: 0 } } : { height: "0", opacity: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, transition: { delay: 0 } }}
                                                >

                                                    
                                                    <motion.div className="order-action bkRed"
                                                        initial={{ opacity: 0 }}
                                                        animate={showOrderAction == index? { opacity: 1 } : { opacity: 0 }}
                                                        onClick={() => {
                                                            setSelectedOrder(item);
                                                            setShowOrdersOverlay(true);
                                                        }}

                                                    >
                                                        <p>Details</p>
                                                    </motion.div>
                                                    <motion.div className="order-action bkYellow"
                                                        initial={{ opacity: 0 }}
                                                        animate={showOrderAction == index? { opacity: 1 } : { opacity: 0 }}
                                                        onClick={()=> {
                                                            setSelectedOrder(item)
                                                            setShowCancelDetailOverlay(true);
                                                        }}
                                                    >
                                                        <p>Cancel</p>
                                                    </motion.div>
                                                </motion.div>
                                            </div>
                                        )
                                    })
                                }
                                


                                

                            </div>

                            

                            
                            
                        </div>

                        <div className="right-orders ">
                            <div 
                            className="order-action-btn  white-text flex align-center justify-center orange-back margin-bottom20" 
                            id="show-overlay-btn2"
                            onClick={()=> {
                                setPage1(false)
                                setPage2(true)
                            }}
                            
                            >
                                    <p>Commander Maintenant</p>
                            </div>

                            <p className="grey-text">Voici quelques statistiques sur vos commandes :</p>

                            <div className="client-stat-container flex flex-column align-center space-evenly max-width white-back margin-bottom20 margin-top20">
                                <p>Nombre d'Ordre</p>

                                <div className="client-stat-circle flex align-center justify-center">
                                    {allOrders.length}
                                </div>
                            </div>

                            <div className="client-stat-container flex flex-column align-center space-evenly max-width white-back margin-bottom20 ">
                                <p>Ordre Livré</p>

                                <div className="client-stat-circle flex align-center justify-center">
                                    {delivredCount}
                                </div>
                            </div>

                            <div className="client-stat-container flex flex-column align-center space-evenly max-width white-back margin-bottom20 ">
                                <p>Ordre En Attente</p>

                                <div className="client-stat-circle flex align-center justify-center">
                                    {waitingCount}
                                </div>
                            </div>

                            <div className="client-stat-container flex flex-column align-center space-evenly max-width white-back margin-bottom20 ">
                                <p>Ordre Annulé</p>

                                <div className="client-stat-circle flex align-center justify-center">
                                    {CanceledCount}
                                </div>
                            </div>
                        </div>
                        
                    </motion.div>
                    :
                    null
                    }

                    


                        < OrdersForm clientId={location.state.userId} anime={page2}/>
                        
                </div>
           




           
       </motion.div>


           <motion.div
                className="loading-icon bold"
                initial={{ opacity: 0 }}
                animate={loading ? { opacity: 1, transition: { delay: 0 } } : { opacity: 0 }}

            >
                <motion.img src={loadingIcon} alt="" className="loading-icon" />
                <p>Veuillez patienter</p>
            </motion.div>

            <motion.div
                className="overlay white-text flex align-center justify-center bold max-width max-height orange-back absolute"
                initial={{ opacity: 0, display: "none" }}

            >

                <div
                    id="signIn-overlay"
                    className="signin-overlay black-text white-back flex flex-column  align-center justify-center bold">

                    <p className="main-form-text">Create your account to join us</p>
                    <p className="grey-text margin-bottom20">Please Fill the Form Below to Enter</p>

                    <div className="form-container">
                        <div className="input-groupe flex">
                            <div className="input-container margin-right20">
                                <p>Name</p>
                                <input type="text" placeholder="Enter Your Username Here" value={clientName} onChange={(e) => {
                                    setClientName(e.target.value)

                                }}/>
                            </div>
                            <div className="input-container margin-bottom20">
                                <div className="input-container">
                                    <p>Phone Number</p>
                                    <input type="text" placeholder="Enter Your Password Here" value={phone} onChange={(e) => {
                                        setPhone(e.target.value)

                                    }}/>
                                </div>
                            </div>
                        </div>

                        

                        <div className="input-groupe flex">
                            <div className="input-container margin-right20">
                                <p>Charging Location</p>
                                <input type="text" placeholder="Enter Your Username Here" value={charging_location} onChange={(e)=> {
                                    setCharging(e.target.value)
                
                            }}
                            />
                            </div>
                            <div className="input-container margin-bottom20">
                                <div className="input-container">
                                    <p>Discharging Location</p>
                                    <input type="text" placeholder="Enter Your Password Here" value={discharging_location} onChange={(e) => {
                                        setDischarging_location(e.target.value)

                                    }}/>
                                </div>
                            </div>
                        </div>

                        <div className="input-groupe flex">
                            <div className="input-container margin-right20">
                                <p>Size</p>
                                <input type="text" placeholder="Enter Your Username Here" value={size} onChange={(e) => {
                                    setSize(e.target.value)

                                }} />
                            </div>
                            <div className="input-container margin-bottom20">
                                <div className="input-container">
                                    <p>Weight</p>
                                    <input type="text" placeholder="Enter Your Password Here" value={weight} onChange={(e) => {
                                        setWeight(e.target.value)

                                    }} />
                                </div>
                                </div>
                        </div>

                        <div className="input-groupe flex">
                            <div className="input-container margin-right20">
                                <p>Vehicle Type</p>
                                <select name="" id="" value={vehicle_type} onChange={(e) => {
                                    setVehicle_type(e.target.value)

                                }}>
                                    <option value="semi-remorque">Semi-remorque</option>
                                    <option value="fourgon">fourgon</option>
                                </select>
                            </div>
                            <div className="input-container margin-bottom20">
                                <div className="input-container">
                                    <p>Payment Method</p>
                                    <select name="" id="" value={payment_method} onChange={(e) => {
                                        setPayment_method(e.target.value)

                                    }}>
                                        <option value="Hand-to-Hand">Hand-to-Hand</option>
                                        <option value="Check">Check</option>
                                        <option value="Bill">Bill</option>
                                        <option value="Bank Transfer">Bank Transfer</option>
                                    </select>
                                </div>
                            </div>
                        </div>



                        <div className="form-actions flex align-center space-between ">
                            <p className="grey-text cursor"></p>
                            <div className="btn orange-back flex align-center "
                            onClick={()=> {
                                //writeUserData(45 ,"lmou" , "hatem6718@gmail.com" , "http://scscscs" )
                                SaveShipment()
                            }}
                            >
                                <p>Submit Now ss</p>

                            </div>

                        </div>
                    </div>
                </div>


            </motion.div>


            <motion.div 
                className="overlay max-width max-height flex-column bold align-center justify-center confirme-overlay"
                initial={{ opacity: 0 , display: "none"}}
                animate={showLogOutOverlay ? { opacity: 1, display: "flex" } : { opacity: 0 }}
            >

                <div 
                id="logout-conf"
                className="logout-conf white-back flex flex-column align-center justify-center">
                    <p>Voulez-vous vous déconnecter ?</p>

                        <div className="logout-actions flex bold align-center justify-center margin-top20">
                        <div className="btn flex orange-back align-center justify-center"
                        onClick={()=> {
                            logoutHandler()
                        }}
                        
                        >Oui</div>
                        <div className="btn flex  align-center justify-center cancel-action"
                            onClick={() => {
                                setShowLogOutOverlay(false)
                            }}
                        >Annuler</div>
                    </div>
                </div>
            </motion.div>



            <motion.div className="order-details-container "
            initial={{display:"none"}}
            animate={showOrdersOverlay ? {display:"flex" , opacity : 1 , scale : 1} : {display:"none" , opacity : 0 , scale : .5}}
            >
                    <OrderDetails close={setShowOrdersOverlay} order={selectedOrder} ></OrderDetails>
            </motion.div>

            {
                showCancelDetailOverlay?
                    <CancelDetailOverlay order={selectedOrder} anime={showCancelDetailOverlay} close={() => { setShowCancelDetailOverlay(false); }}  cancelOrder={cancelOrder} />
                :
                null
            }
            
       </div>

    );

}

export default ClientSpace;